/**
 * Scrolls the page to the specified anchor element with an offset for the sticky menu.
 * @param anchorId The ID of the element to scroll to
 * @returns Boolean indicating if scrolling was performed
 */
export function scrollToAnchor(anchorId: string): boolean {
    const element = document.getElementById(anchorId)
    if (element) {
        const menu = document.querySelector('.sticky-menu')
        const menuHeight = menu ? menu.getBoundingClientRect().height : 0

        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
        const offsetPosition = elementPosition - menuHeight - 5

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        })

        return true // Scrolling was performed
    }
    return false // Element not found
}
